document.addEventListener("DOMContentLoaded", function() {
  const intervalId = setInterval(() => {
    const tcElements = document.querySelectorAll('tc-money.money-done--USD');

    tcElements.forEach(el => {
      const parent = el.closest('[data-price]');
      if(parent) {
        const realPrice = parent.getAttribute('data-price');
        el.textContent = realPrice;
        el.setAttribute('data-tc-price', realPrice);
      }
    });
  }, 100);

  setTimeout(() => clearInterval(intervalId), 2000);
});